/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-09T11:53:38-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-07T13:19:45-07:00
*/



import React, { Component } from 'react';
import Container from '../../blocks/Container';
import ResultList from '../../blocks/ResultList';
import BlankSlate from '../../blocks/BlankSlate';
import userItem from '../../common/userItemFactory';
import isEmpty from 'lodash/isEmpty';

class FavoritedMeList extends Component {

  favList = () => {
    const {
      favs,
      isFetching,
      noResultsTitle,
      noResultsMsg,
      toggle
    } = this.props;

    const UserItem = userItem();

    if(isEmpty(favs)) {
      return (<BlankSlate title={noResultsTitle} msg={noResultsMsg} />);
    } else {
      const FavList = Object.keys(favs).map((key) => {
        const acct = favs[key].other_account.data;
        const profile = acct.profile ? acct.profile.data : null;

        if(profile) {
          return (
            <UserItem key={key}
              favKey={key}
              title={acct.username}
              city={profile.city}
              age={profile.age}
              region={profile.region}
              country={profile.country}
              description={profile.description}
              avatar={profile.avatar.data.urls.thumbs}
              isFavorite={acct.is_favorite}
              toggle={toggle}
            />
          );
        }
      });

      return (
        <ResultList>
          {FavList}
        </ResultList>
      )
    }
  }

  render() {
    return (
      <Container>
        {this.favList()}
      </Container>
    );
  }
}



export default FavoritedMeList;



// WEBPACK FOOTER //
// ./src/components/pages/Favorites/FavoritedList.jsx